// extracted by mini-css-extract-plugin
module.exports = {"container":"WeekHeader_container__3KGsJ","active":"WeekHeader_active__nnc1P","day":"WeekHeader_day__3oJjU","month":"WeekHeader_month__V3_r2"};